import { PRIORITY, STATUS } from '@/entities/alert/model/types';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

const GetLinkedAlertsResponseDtoSchema = PagePaginationResponseDtoSchema(
  z.object({
    alert: z.string(),
    createdAt: z.string(),
    id: z.number(),
    priority: z.enum(PRIORITY).nullable(),
    status: z.enum(STATUS),
  })
);

export type GetLinkedAlertsRequestDto = PagePaginationRequestDto<
  {
    id: number;
    statuses?: STATUS[];
    priorities?: PRIORITY[];
  },
  'createdAt' | 'status' | 'priority'
>;
export type GetLinkedAlertsResponseDto = z.infer<
  typeof GetLinkedAlertsResponseDtoSchema
>;

export const getLinkedAlerts = (
  params: GetLinkedAlertsRequestDto,
  config?: AxiosRequestConfig<GetLinkedAlertsRequestDto>
) => {
  const { id, ...restParams } = params;

  return api
    .get(`alerts/${id}/linked`, { params: restParams, ...config })
    .then(responseContract(GetLinkedAlertsResponseDtoSchema));
};
